import React, { Component } from "react";
// import gitDiff from "git-diff";
import Diff from "text-diff";

import "../css/SwaggerDiff.css";

import SwaggerAPI from "../api/SwaggerAPI";
import Menu from "./swaggers-diff/Menu";
import DiffView from "./swaggers-diff/DiffView";

class SwaggerDiff extends Component {
  constructor(props) {
    super(props);

    this.state = {
      versions: [],
      diff: ""
    };
  }

  componentDidMount() {
    SwaggerAPI.getSwaggerVersions(
      this.props.match.params.groupId,
      this.props.match.params.swaggerId
    ).then(versions => {
      this.setState({ versions });
    });
  }

  compare = (versionA, versionB) => {
    const version1 = SwaggerAPI.getSwaggerVersion(
      this.props.match.params.groupId,
      this.props.match.params.swaggerId,
      versionA
    );
    const version2 = SwaggerAPI.getSwaggerVersion(
      this.props.match.params.groupId,
      this.props.match.params.swaggerId,
      versionB
    );
    Promise.all([version1, version2]).then(([v1, v2]) => {
      const diff = new Diff();
      const textDiff = diff.main(v1.content, v2.content);
      const htmlTextDiff = diff.prettyHtml(textDiff);
      this.setState({
        diff: htmlTextDiff //gitDiff(v1.content, v2.content)
      });
    });
  };

  render() {
    return (
      <div className="compare-div">
        <Menu versions={this.state.versions} compare={this.compare} />
        <DiffView diff={this.state.diff}/>
      </div>
    );
  }
}

export default SwaggerDiff;



// WEBPACK FOOTER //
// ./src/components/SwaggerDiff.js